import React, { Component } from "react";
import Data from "../../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";
import HttpUtil from '../../commonjs/HttpUtil';
import RequestUrl from '../../commonjs/urlConfiger';
let _Gitv = window.gitv;
_Gitv && _Gitv.onInit ? _Gitv.onInit() : '';
export default class Agreement extends Component {
    constructor(props) {
        super(props);
        this.state = {
          data:{},
        };
    }

    componentDidMount() {

    }

    componentWillMount() {
        this.getContent();
        _Gitv && _Gitv.setExitOnNextBack ? _Gitv.setExitOnNextBack("true") : '';
    }

    //获取页面数据
    getContent = () => {
        HttpUtil.get(RequestUrl.getContent()).then((json) => {
          console.log("getPage----" + JSON.stringify(json))
          const pageMap = json || {};
          if (pageMap.code == 'A000000') {
            const data = pageMap;
            // RequestUrl.getPBEnter({ot:"1",pan:pageTitle },"0");
            this.setState({ data });
            return 
          } else {
            this.setNodataText()
            this.setState({ pubType:'tips', errorTips: '网络连接失败，请稍后再试~' })
          }
        }, (json) => {
          this.setNodataText()
          this.setState({ pubType: 'tips', errorTips: '网络连接失败，请稍后再试~' })
        });
      }

    setNodataText(){
      let nodatahml = '<div class="page-agreement-no-data"><span>暂时无数据</span></div>'
      this.setState({data:{data:{html:nodatahml}}})
    }
    render() {
        const { pubType = '', data = {} } = this.state;
        return (
            <ScrollView data={data}>
                <Content data={data} />
                {
                pubType == "tips" ? <div className="com-tips">{this.state.errorTips}</div> : ""
                }
            </ScrollView>
        );
    }

}


// WEBPACK FOOTER //
// ./src/component/agreement/index.js